module.exports = fox._r("images/background/join-right.jpg", __webpack_public_path__ + "images/background/join-right.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/background/join-right.jpg
// module id = 985
// module chunks = 4